module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-layout', [_c('v-flex', {
    staticClass: "ml-2 mr-2"
  }, [_c('v-select', {
    attrs: {
      "items": _vm.tags,
      "item-text": "name",
      "item-value": "id",
      "label": "Select Tags",
      "max-height": "400",
      "autocomplete": "",
      "append-icon": "local_offer",
      "multiple": ""
    },
    model: {
      value: (_vm.filters.tags),
      callback: function($$v) {
        _vm.$set(_vm.filters, "tags", $$v)
      },
      expression: "filters.tags"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    staticClass: "ml-2 mr-2"
  }, [_c('v-select', {
    attrs: {
      "items": _vm.times,
      "max-height": "400"
    },
    model: {
      value: (_vm.filters.time),
      callback: function($$v) {
        _vm.$set(_vm.filters, "time", $$v)
      },
      expression: "filters.time"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    staticClass: "ml-2 mr-2"
  }, [_c('v-select', {
    attrs: {
      "label": "Sort By",
      "items": _vm.sorts,
      "max-height": "400"
    },
    model: {
      value: (_vm.filters.sort),
      callback: function($$v) {
        _vm.$set(_vm.filters, "sort", $$v)
      },
      expression: "filters.sort"
    }
  })], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-e33008c0","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Pages/Home/filters.vue
// module id = 402
// module chunks = 0